import React from 'react';
import Carousel from './carousel';


class VenueImageGallery extends React.Component{

  render(){


    var whenNoImage = ["https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/venue_fallback.png"];
    try{
      var gallery =  [this.props.imageUrl];
    }catch(err){
        gallery = whenNoImage;
    }


    return (
      <div className="offer-max-width-carousel">
        <Carousel venueImages= {gallery} viewport = {this.props.viewport} name={this.props.name}/>
      </div>
    )
  }
}

export default VenueImageGallery;



// WEBPACK FOOTER //
// ./src/components/Offer-detail-page/ImageGallery/venueImageGallery.js